import { Params } from 'react-router';
import Toast from '../Toast';
import { ApiResponse, axios } from '../config/axios';
import config from '../config/config';
import TagsService from './TagsService';
import { UpdateUserType, UserType } from '../types/UserType';

export const UserService = {
  async getPorfile(): Promise<ApiResponse<UserType>> {
    return await axios.get(`/user/profile-information`);
  },
  async updateProfile(data: UpdateUserType) {
    try {
      const response: { data: any; message: string } = await axios.patch(
        `${config.baseUrl}/user/profile-information`,
        data
      );
      Toast.success(response?.message);
      return { success: true, response };
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};

export default UserService;
